"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AppCategoryCarousel = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouter = require("react-router");
var _QuickHelp = _interopRequireDefault(require("@concur/nui-widgets/lib/Popover/QuickHelp"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Carousel = _interopRequireDefault(require("@concur/nui-widgets/Carousel"));
var _useResizeObserver2 = _interopRequireDefault(require("@concur/nui-widgets/lib/utils/useResizeObserver"));
var _MiniListing = _interopRequireDefault(require("../shared/MiniListing"));
var _utils = require("../utils");
var _config = _interopRequireDefault(require("../config"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AppCategoryCarousel = exports.AppCategoryCarousel = function AppCategoryCarousel(_ref) {
  var categoryTitle = _ref.categoryTitle,
    categorySubtitle = _ref.categorySubtitle,
    categoryQuickHelpMessage = _ref.categoryQuickHelpMessage,
    _ref$listings = _ref.listings,
    listings = _ref$listings === void 0 ? [] : _ref$listings,
    isLoggedIn = _ref.isLoggedIn,
    betas = _ref.betas,
    dataTestId = _ref.dataTestId,
    formatter = _ref.formatter;
  var carouselContainerRef = (0, _react.useRef)(null);
  var _useResizeObserver = (0, _useResizeObserver2.default)({
      targetRef: carouselContainerRef
    }),
    containerWidth = _useResizeObserver.width;
  var columnsCount = (0, _react.useMemo)(function () {
    if (containerWidth <= 390) return 1;
    if (containerWidth <= 580) return 2;
    if (containerWidth <= 768) return 3;
    if (containerWidth <= 980) return 4;
    if (containerWidth <= 10000) return 6;
    return 1;
  }, [containerWidth]);
  var location = (0, _reactRouter.useLocation)();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    startIndex = _useState2[0],
    setStartIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    endIndex = _useState4[0],
    setEndIndex = _useState4[1];

  // returns true if index is between the start and end indexes
  // if start/end are negative, convert to the positive versions instead
  // Ex. if listings length is 30, an index of -5 should refer to index 25 instead of -5
  var shouldLoadImage = (0, _react.useCallback)(function (start, end, index) {
    // index passed in will always be positive & will be between 0 to listings.length - 1
    // start & end not guaranteed to be positive, so we need to check
    var positiveStartIndex = start < 0 ? listings.length + start : start;
    var positiveEndIndex = end < 0 ? listings.length + end : end;
    return positiveStartIndex <= index && positiveEndIndex >= index;
  });
  var miniListing = function miniListing() {
    return listings.map(function (listing, i) {
      var listingLink = "".concat((0, _utils.getAppCenterPathName)(location.pathname), "/listings/").concat(listing.ID);
      var isListingWithLogo = (0, _utils.canAccessBeta)(betas, 'triplink-app-flags') && listing.core.isTriplinkPreferredApp || (listing.core.categories || []).includes('ENDORSED_APPS') && ((0, _utils.canAccessBeta)(betas, 'endorsed-apps-category') || _config.default.nui.endorsedCategoryEnabled);
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
        key: listing.ID,
        to: listingLink,
        className: "mini-listing-link",
        "data-analytics": "ec=".concat(listing.localized.name, "\n      |ea=ViewDetails\n      |dp=Home\n      |dt=AppCenterHome\n      |cd2=nui")
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          display: 'inline-block'
        }
      }, /*#__PURE__*/_react.default.createElement(_MiniListing.default, {
        listing: listing,
        shouldLoadImage: shouldLoadImage(startIndex, endIndex, i) || shouldLoadImage(startIndex - columnsCount, endIndex - columnsCount, i) || shouldLoadImage(startIndex + columnsCount, endIndex + columnsCount, i),
        isLoggedIn: isLoggedIn,
        betas: betas
      }))), /*#__PURE__*/_react.default.createElement(_reactRouter.Link, {
        to: listingLink,
        tabIndex: "0",
        className: "overlay".concat(isListingWithLogo ? ' overlay-is-with-logo' : '', " mini-listing")
      }, listing.localized.summary));
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": dataTestId
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "collection-title"
  }, categoryTitle), categoryQuickHelpMessage ? /*#__PURE__*/_react.default.createElement(_QuickHelp.default, {
    message: categoryQuickHelpMessage,
    textShowQuickHelp: formatter.formattedMessage({
      id: 'QuickHelpLabel',
      values: {
        collection: categoryTitle
      }
    }),
    title: categoryTitle,
    textClose: formatter.formattedMessage({
      id: 'Close'
    }),
    className: "collection-quick-help",
    "data-testid": dataTestId ? "".concat(dataTestId, "-QuickHelp") : ''
  }) : null, /*#__PURE__*/_react.default.createElement("p", {
    className: "collection-description"
  }, categorySubtitle), /*#__PURE__*/_react.default.createElement("div", {
    ref: carouselContainerRef
  }, /*#__PURE__*/_react.default.createElement(_Carousel.default, {
    slides: miniListing(),
    ariaLabel: categoryTitle,
    previousButtonLabel: formatter.formattedMessage({
      id: 'btnPreviousPageMouseover'
    }),
    nextButtonLabel: formatter.formattedMessage({
      id: 'btnNextPageMouseover'
    }),
    pageSize: columnsCount,
    carouselBackground: "transparent",
    pageIndicatorBackground: "transparent",
    disablePageIndicatorBorder: "true",
    disablePageIndicator: "true",
    pageIndicatorText: function pageIndicatorText(_ref2) {
      var slideCount = _ref2.slideCount,
        pageCount = _ref2.pageCount,
        currentPageIndex = _ref2.currentPageIndex,
        pageSize = _ref2.pageSize,
        slidesOnCurrentPage = _ref2.slidesOnCurrentPage;
      var start = currentPageIndex * pageSize + 1;
      var end = slidesOnCurrentPage === 1 ? '' : " - ".concat(Math.min(start + pageSize - 1, slideCount));

      // startIndex is the index of the first listing that is shown on the current carousel page
      setStartIndex(currentPageIndex * pageSize);
      // endIndex is the index of the last listing that is shown on the current carousel page
      setEndIndex(slidesOnCurrentPage === 1 ? currentPageIndex * pageSize : Math.min(start + pageSize - 1, slideCount) - 1);
      var startEnd = "".concat(start).concat(end);
      return pageSize > 1 ? formatter.formattedMessage({
        id: 'AppCenterV2.pageNumberOfTotal',
        values: {
          index: startEnd,
          total: slideCount
        }
      }) : formatter.formattedMessage({
        id: 'AppCenterV2.pageNumberOfTotal',
        values: {
          index: currentPageIndex + 1,
          total: pageCount
        }
      });
    }
  }))));
};
AppCategoryCarousel.propTypes = {
  categoryTitle: _propTypes.default.string.isRequired,
  categorySubtitle: _propTypes.default.any.isRequired,
  categoryQuickHelpMessage: _propTypes.default.any,
  listings: _propTypes.default.array.isRequired,
  isLoggedIn: _propTypes.default.bool.isRequired,
  betas: _propTypes.default.object,
  dataTestId: _propTypes.default.string,
  formatter: _propTypes.default.shape({
    formattedMessage: _propTypes.default.func.isRequired
  }).isRequired
};
var _default = exports.default = (0, _nuiIntlRuntime.withFormatter)(AppCategoryCarousel);